"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var ReporterActionTypes;

(function (ReporterActionTypes) {
  ReporterActionTypes["ROUTE_STARTED"] = "ROUTE_STARTED";
  ReporterActionTypes["ROUTE_UNEXPECTED"] = "ROUTE_UNEXPECTED";
  ReporterActionTypes["ROUTE_SUCCEEDED"] = "ROUTE_SUCCEEDED";
  ReporterActionTypes["ROUTE_FAILED"] = "ROUTE_FAILED";
  ReporterActionTypes["ROUTE_TIMEOUT_EXPIRED"] = "ROUTE_TIMEOUT_EXPIRED";
  ReporterActionTypes["ROUTE_ABANDONED"] = "ROUTE_ABANDONED";
  ReporterActionTypes["CHECKS_CHANGED"] = "CHECKS_CHANGED";
})(ReporterActionTypes || (ReporterActionTypes = {}));

var _default = ReporterActionTypes;
exports.default = _default;
module.exports = exports.default;